// Editable site constants — replace the placeholder phone number with the real one.
export const CONTACT = {
    email: "hitanshuwork02@gmail.com",
    phone: "+91 70452 21800",
    location: "Mumbai, India",
};

export const BRANDS = [
    "Nestlé",
    "TRESemmé",
    "Bru Coffee",
    "Netflix",
    "Traya",
    "ICICI Prudential",
    "Adani Defence",
    "Cipla",
    "MX Fatafat",
    "Veeba Sauces",
    "BGMI",
];

export const SERVICES = [
    "Advertising Films",
    "Brand Films",
    "Corporate Films",
    "Product Films",
    "Product Photography & Videography",
    "Music Videos",
    "Short Films",
    "Fashion & Lifestyle Films",
    "Social Media Content",
    "Reels & Digital Campaigns",
    "Documentary-style Films",
];

export const CATEGORIES = SERVICES;

export const VALUES = [
    "Creativity over formulas",
    "Visual storytelling",
    "Attention to detail",
    "Collaboration",
    "Continuous learning",
    "Professionalism",
    "Experimentation",
    "Purpose behind every frame",
];
